import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";

import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Button,
  Label,
  Table,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import cellEditFactory from "react-bootstrap-table2-editor";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "../../../../../node_modules/react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import {
  convertToLowestUnit,
  formatUnitsForReport,
  GetUpdatedDelivered,
} from "../../../../helpers/units";
import preloader from "../../../../helpers/preloader";
import showNotification from "../../../../helpers/show_notification";
import {
  handleCheckboxChange,
  handleQuantityChange,
} from "../../../../helpers/po_helper";
import printDiv from "../../../../helpers/print_data";
import OrderDetails from "../../../../components/Orders/Items/DeficitOrderDetails";
import UpdateQuantityModal from "../../../../components/UpdateQuantityModal";
const animatedComponents = makeAnimated();

const DeficitOrders = (props) => {
  const [receiveBtnDisabled, setReceiveBtnDisabled] = useState(false);
  const { SearchBar } = Search;
  const [dateFrom, setDateFrom] = useState(() => {
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1,
    );
    return firstDay;
  });
  const [dateTo, setDateTo] = useState();
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  useEffect(() => {
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1,
    );
    setDateFrom(formatDate(firstDay));
    setDateTo(formatDate(currentDay));
    loadAllOrders();
    loadAllItems();
  }, []);

  const [remarks, setRemarks] = useState();

  const [allOrders, setAllOrders] = useState([]);
  const [allOrdersFiltered, setAllOrdersFiltered] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [received, setRecieved] = useState([]);
  const [yetToReceive, setYetToReceive] = useState([]);
  const loadAllOrders = async () => {
    const days_diff = moment(dateTo).diff(dateFrom, "days");
    if (days_diff > 30) {
      setAllOrders([]);
      showNotification("Total number of days cannot be more than 31.", "Error");
      return false;
    } else if (days_diff < 0) {
      setAllOrders([]);
      showNotification("Invalid date range.", "Error");
      return false;
    }
    // console.log(days_diff);
    preloader(true);
    let date_from = moment(dateFrom).format("YYYY-MM-DD"),
      date_to = moment(dateTo).format("YYYY-MM-DD");
    // console.log(date_from, date_to);
    let url = process.env.REACT_APP_BASEURL + "itemorders/getforbranch";
    const response = await postSubmitForm(url, { date_from, date_to });
    let filtered = response.data.filter((item) =>
      item.order_for ? item.order_for === "substore deficit" : " ",
    );
    if (response && response.status === 1) {
      preloader(false);
      // let expandedRows = [];
      // response.data.map((item) => {
      //   if (item.status !== "Closed" && item.status !== "Rejected") {
      //     expandedRows.push(item._id);
      //   }
      // });
      setAllOrders(filtered);
      // setExpanded(expandedRows);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };
  useEffect(() => {
    if (selectedStatus) {
      if (selectedStatus === "All") {
        setAllOrdersFiltered(allOrders);
      } else {
        var data = JSON.parse(JSON.stringify(allOrders));
        setAllOrdersFiltered(
          data.filter((order) => order.status === selectedStatus),
        );
      }
    }
  }, [allOrders, selectedStatus]);

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "category",
      text: props.t("Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      sort: true,
    },
    {
      dataField: "available",
      text: props.t("Sub Store Avl. Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.available, row.unitLevels);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Order Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];
  const [selectedOrder, setSelectedOrder] = useState();
  const [editModal, setEditModal] = useState();
  const columns_external = [
    {
      dataField: "_id",
      hidden: true,
      csvExport: false,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      csvExport: false,
    },
    {
      dataField: "order_id",
      text: props.t("Order ID"),

      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },

      style: { cursor: "pointer" },
    },
    {
      dataField: "remarks",
      text: props.t("Remarks"),

      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },

      style: { cursor: "pointer" },
    },
    {
      text: props.t("Order Date"),
      dataField: "createdAt",
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      style: { cursor: "pointer" },
    },
    {
      dataField: "status",
      text: props.t("Status"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      style: { cursor: "pointer" },
    },
    {
      dataField: "admin_remarks",
      text: props.t("Centre Remarks"),

      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },

      style: { cursor: "pointer" },
    },
    {
      dataField: "",
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      csvExport: false,
      formatter: (cell, row) => {
        if (row.status === "Placed") {
          return (
            <span className="text-primary">
              <i
                className="bx bxs-edit font-size-15"
                title="Click to Edit"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setReceiveBtnDisabled(false);
                  setEditModal(!editModal);
                  setSelectedOrder(row);
                  //setIsUrgent(row.is_urgent);
                  setItemsForOrder(row.item_details);
                  setRemarks(row.remarks);
                }}
              ></i>
            </span>
          );
        } else {
          return (
            <span className="text-primary">
              <i
                className="mdi mdi-text-box-search font-size-15"
                title="Click to View Details"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setDetailsModal(!detailsModal);
                  setSelectedOrder(row);
                  let received_items = [];
                  let to_receive_items = [];
                  // console.log();
                  row.delivery_details.map((item) => {
                    if (item.is_received) {
                      received_items.push(item);
                    } else {
                      item.received_quantity = item.delivered_quantity;
                      item.original_delivered_quantity =
                        item.original_delivered_quantity;
                      to_receive_items.push(item);
                    }
                  });
                  setRecieved(received_items);
                  setYetToReceive(to_receive_items);
                }}
              ></i>
            </span>
          );
        }
      },
    },
  ];

  const handleOnExpand = (row, isExpand, rowIndex, e) => {
    if (isExpand) {
      setExpanded([...expanded, row._id]);
    } else {
      setExpanded(expanded.filter((x) => x !== row._id));
    }
  };
  const [expanded, setExpanded] = useState([]);
  const expandRow = {
    onlyOneExpanding: true,
    renderer: (row) => (
      <div>
        <BootstrapTable
          bootstrap4
          keyField="_id"
          data={row.item_details}
          columns={columns}
          noDataIndication="No data to display."
          striped
          hover
          condensed
        />
      </div>
    ),
    expanded: expanded,
    onExpand: handleOnExpand,
  };

  const rowStyle = (row, rowIndex) => {
    const style = { backgroundColor: "#fffbb8", fontWeight: "500" };
    if (row.status === "Closed") {
      style.backgroundColor = "#b8ffb9";
    } else if (row.status === "Placed") {
      style.backgroundColor = "#ffb8b8";
    } else if (row.status === "Rejected") {
      style.backgroundColor = "#f1b8ff";
    } else {
      style.backgroundColor = "#b8cdff";
    }
    return style;
  };
  function compareQuantities(item) {
    const quantities = item.received_quantity;
    const quantitiesToCompare = item.delivered_quantity;
    const unitLevels = item.unit_levels;
    const convertedQuantities = convertToLowestUnit(unitLevels, quantities);
    const convertedQuantitiesToCompare = convertToLowestUnit(
      unitLevels,
      quantitiesToCompare,
    );
    let isPartial = false;
    if (convertedQuantities < convertedQuantitiesToCompare) {
      isPartial = true;
    }
    return isPartial;
  }
  const [detailsModal, setDetailsModal] = useState(false);
  const handleReceiveItemOrder = async (e, v) => {
    setReceiveBtnDisabled(true);
    let itemorder_id = selectedOrder._id;
    let delivery_details = [];
    for (let i = 0; i < yetToReceive.length; i++) {
      delivery_details.push({
        _id: yetToReceive[i]._id,
        item_id: yetToReceive[i].item_id,
        received_quantity: yetToReceive[i].received_quantity,
        original_delivered_quantity:
          yetToReceive[i].original_delivered_quantity,
        unit_levels: yetToReceive[i].unit_levels,
        cost_price: yetToReceive[i].cost_price,
        selling_price: yetToReceive[i].selling_price,
        batch: yetToReceive[i].batch,
        remarks: yetToReceive[i].remarks,
      });
    }
    const data_to_send = {
      itemorder_id,
      delivery_details,
    };
    let isNoRemarkUpdated = false;
    for (let item of yetToReceive) {
      isNoRemarkUpdated = compareQuantities(item);
      if (isNoRemarkUpdated && item.remarks === "") {
        showNotification(
          "Enter remarks for all variances in received products.",
          "Warning",
        );
        break;
      }
    }
    // console.log(data_to_send,"pay");
    // return
    if (!isNoRemarkUpdated) {
      let url = process.env.REACT_APP_BASEURL + "itemorders/receive_by_branch";
      const response = await postSubmitForm(url, data_to_send);

      if (response && response.status === 1) {
        loadAllOrders();

        setDetailsModal(!detailsModal);
        showNotification(response.message, "Success");
      } else {
        showNotification(response.message, "Error");
      }
    } else {
      setReceiveBtnDisabled(false);
      showNotification(
        "Enter remarks for all variances in received items.",
        "Warning",
      );
    }
  };
  const columns_received = [
    {
      dataField: "category",
      text: props.t("Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      sort: true,
    },

    {
      text: props.t("Dispatch Time"),
      dataField: "date_of_transaction",
      formatter: (cell, row) => {
        return moment(row.date_of_transaction).format("DD/MM/YYYY HH:mm");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "delivered_quantity",
      text: props.t("Del. Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.delivered_quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "received_quantity",
      text: props.t("Rec. Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.received_quantity);
      },

      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Remarks"),
      dataField: "remarks",

      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  ];

  const [receiveModal, setReceiveModal] = useState(false);
  function ReceiveFormatter(cell, row) {
    return (
      <>
        <div className="d-flex align-items-center justify-content-between">
          <span className="me-2">
            {formatUnitsForReport(
              row.received_quantity && row.received_quantity,
            )}
          </span>
          {selectedOrder && selectedOrder.is_received !== true && (
            <Button
              className="btn btn-success btn-sm"
              onClick={() => {
                const updatedItem = {
                  ...row,
                  quantity: row.received_quantity.map((item, idx) => ({
                    ...item,
                    index: idx,
                    isChecked: true,
                  })),
                };
                setSelectedItem(updatedItem);
                setReceiveModal(!receiveModal);
              }}
            >
              <i class="mdi mdi-edit"></i>
              {props.t("Edit")}
            </Button>
          )}
        </div>
      </>
    );
  }
  const columns_yet_to_receive = [
    {
      dataField: "category",
      text: props.t("Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      sort: true,
      editable: false,
    },

    {
      text: props.t("Dispatch Time"),
      dataField: "date_of_transaction",
      formatter: (cell, row) => {
        return moment(row.date_of_transaction).format("DD/MM/YYYY HH:mm");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
    },
    {
      dataField: "delivered_quantity",
      text: props.t("Del. Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(
          row.delivered_quantity && row.delivered_quantity,
        );
      },
      formatExtraData: yetToReceive,
      editable: false,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },

    {
      dataField: "received_quantity",
      text: props.t("Rec. Qty."),
      formatter: ReceiveFormatter,
      // formatter: (cell, row) => {
      //   return formatUnitsForReport(row.received_quantity && row.received_quantity)
      //  },
      attrs: (cell, row, rowIndex, colIndex) => {
        return { title: "Click to Edit" };
      },
      style: (cell, row, rowIndex, colIndex) => {
        return { cursor: "pointer", background: "#ffffaa" };
      },
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "remarks",
      text: props.t("Remarks"),
      // formatter: (cell, row) => {
      //   return <>{row.sub_unit ? +row.received_quantity.in_sub_unit : 0}</>;
      // },
      editable: true,
      attrs: { title: "Click to Edit" },
      style: { cursor: "pointer", background: "#ffffaa" },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];

  //#region  Update related functions

  const refForForm = useRef(null);
  const refSelectItem = useRef(null);
  const [allItems, setAllItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState();
  const loadAllItems = async () => {
    let url = process.env.REACT_APP_BASEURL + "branchitems/getforbranch";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      let filtered = response.data?.filter((d) => d.is_active) || [];
      setAllItems(filtered);
    } else {
      showNotification(response.message, "Error");
    }
  };
  const [itemsForOrder, setItemsForOrder] = useState([]);
  const handleValidUpdate = async (e, v) => {
    try {
      const object = {
        id: selectedOrder._id,
        item_details: itemsForOrder,
        //is_urgent: isUrgent,
        remarks: v.remarks,
      };
      let url = process.env.REACT_APP_BASEURL + "itemorders/update";
      let response = await postSubmitForm(url, object);
      if (response.status === 1) {
        loadAllOrders();
        setEditModal(!editModal);
        setRemarks();
        setItemsForOrder([]);
        setSelectedItem();
        refSelectItem.current.select.clearValue();
        refForForm.current.reset();
        showNotification(response.message, "Success");
        refForForm.current.reset();
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    }
  };
  function deleteFormatter(cell, row, rowIndex, extraData) {
    return (
      <>
        <span className="text-danger">
          <i
            className="bx bxs-trash font-size-15"
            title="Click to Delete"
            style={{ cursor: "pointer" }}
            onClick={() => {
              let arr = extraData.filter(
                (item) => item.item_id !== row.item_id,
              );

              setItemsForOrder(arr);
            }}
          ></i>
        </span>
      </>
    );
  }
  const columns_items = [
    {
      dataField: "category",
      text: props.t("Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      sort: true,
    },
    {
      dataField: "available",
      text: props.t("Available"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.available, row.unit_levels);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Order Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      text: props.t("Remove"),
      formatter: deleteFormatter,
      formatExtraData: itemsForOrder,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];
  //#endregion Update related functions
  const [orderModal, setOrderModal] = useState(false);
  const [viewOrderDetails, setViewOrderDetails] = useState({});
  const handleOPenOrder = async () => {
    let url = process.env.REACT_APP_BASEURL + "itemorders/view_orders";
    const response = await postSubmitForm(url, {
      branch_order_id: selectedOrder.branch_order_id,
    });
    if (response && response.status === 1) {
      setViewOrderDetails(response.data[0]);
      setOrderModal(true);
      // showNotification(response.message, "Success");
    } else {
      showNotification(response.message, "Error");
    }
  };
  const handleDownload = async () => {
    const fileName = "all_item_orders";
    const exportType = "xls";

    let data_to_export = allOrders;

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        data.push({
          OrderID: v.order_id,
          Remarks: v.remarks,
          Date: moment(v.date_to_process).format("DD/MM/YYYY HH:mm"),
          IsUrgent: v.is_urgent ? "Yes" : "No",
          Status: v.status,
          CenterRemarks: v.admin_remarks,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };
  const [selectedRowsUnit, setSelectedRowsUnit] = useState([]);
  const [selectUnitModal, setSelectUnitModal] = useState(false);

  function handleCloseModal() {
    setSelectUnitModal(false);
    setSelectedRowsUnit([]);
  }

  const handleAddUnits = async (e, v) => {
    var new_array_items = JSON.parse(JSON.stringify(itemsForOrder));
    const existing_item = new_array_items.filter(function (item) {
      return item.item_id === selectedItem.item_id;
    });

    if (existing_item.length > 0) {
      showNotification(
        props.t("This item is already added."),
        props.t("Error"),
      );
    } else if (selectedItem) {
      let item_to_add = {};
      item_to_add.item_id = selectedItem?.item_id;
      item_to_add.name = selectedItem.name;
      item_to_add.category = selectedItem.category;
      item_to_add.sub_category = selectedItem.sub_category;
      item_to_add.brand = selectedItem.brand;
      item_to_add.available =
        selectedItem.available.map(({ unit, value }) => ({
          unit,
          value: parseFloat(value),
        })) || null;
      item_to_add.quantity =
        selectedRowsUnit.map(({ unit, value }) => ({
          unit,
          value: parseFloat(value),
        })) || null;
      item_to_add.unit_levels = selectedItem.unit_levels;
      item_to_add.expiry_date = selectedItem.expiry_date;
      item_to_add.cost_price = selectedItem.cost_price;
      item_to_add.selling_price = selectedItem.selling_price;
      setItemsForOrder([...itemsForOrder, item_to_add]);
      setSelectUnitModal(false);
      setSelectedItem();
      setSelectedRowsUnit([]);
      refSelectItem.current.select.clearValue();
    } else {
      showNotification(props.t("Select a item batch first."), props.t("Error"));
    }
  };
  const handleSubmit = (quantity) => {
    let totalEntered = convertToLowestUnit(selectedItem.unit_levels, quantity);
    let totalDelivered = convertToLowestUnit(
      selectedItem.unit_levels,
      selectedItem.delivered_quantity,
    );
    if (totalEntered > totalDelivered) {
      showNotification("Can not receive more than delivered", "Warning");
      return;
    }
    let convertedQuantity = GetUpdatedDelivered(
      quantity,
      selectedItem.unit_levels,
    );
    setReceiveModal(!receiveModal);
    const updatedItems = yetToReceive.map((item) => {
      if (item._id === selectedItem._id) {
        // return selectedItem;
        return { ...item, received_quantity: convertedQuantity };
      }
      return item;
    });
    setSelectedItem();
    setYetToReceive(updatedItems);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Items")}
            title={props.t("Orders")}
            breadcrumbItem1={props.t("Items")}
            breadcrumbItem2={props.t("All Orders")}
          />

          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={4}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <Button
                          type="submit"
                          className="btn btn-md btn-success mt-4"
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadAllOrders();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("All Item Orders")}
                    </CardTitle>

                    <ToolkitProvider
                      keyField="_id"
                      data={allOrdersFiltered && allOrdersFiltered}
                      columns={columns_external}
                      noDataIndication={props.t("No data to display.")}
                      bootstrap4
                      search
                      exportCSV
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={5}></Col>
                            <Col lg={3} className="text-right">
                              <select
                                name="status"
                                className="form-control"
                                value={selectedStatus}
                                onChange={(e) => {
                                  setSelectedStatus(e.target.value);
                                }}
                              >
                                <option value="All">All</option>
                                {/* <option value="Placed">Placed</option> */}
                                <option value="Approved">Approved</option>
                                <option value="Dispatched">Dispatched</option>
                                <option value="Closed">Closed</option>
                                <option value="Rejected">Rejected</option>
                              </select>
                            </Col>
                          </Row>

                          <BootstrapTable
                            striped
                            hover
                            condensed
                            expandRow={expandRow}
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {/* Update Order Modal starts */}
      <Modal
        size="lg"
        isOpen={editModal}
        toggle={() => setEditModal(!editModal)}
        onClosed={() => {
          setSelectedItem();
          setSelectedRowsUnit();
        }}
      >
        <ModalHeader toggle={() => setEditModal(!editModal)}>
          {props.t("Update Order")}
        </ModalHeader>
        <ModalBody>
          {selectedOrder && (
            <>
              <Row>
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <AvForm
                        onValidSubmit={() =>
                          setSelectUnitModal(!selectUnitModal)
                        }
                        ref={refForForm}
                      >
                        <Row>
                          <Col lg={5}>
                            <Label>{props.t("Item")}</Label>
                            <Select
                              ref={refSelectItem}
                              value={selectedItem}
                              onChange={(selected) => {
                                setSelectedItem(selected);
                              }}
                              options={allItems}
                              classNamePrefix="select2-selection"
                              components={animatedComponents}
                              required
                            />
                          </Col>

                          <Col lg={2} className="mb-4">
                            <Label>&nbsp;</Label>
                            <br />
                            <Button
                              type="submit"
                              color="primary"
                              className="btn btn-info waves-effect waves-light btn-sm"
                            >
                              <i class="bx bx-add-to-queue"></i>{" "}
                              {props.t("Add")}
                            </Button>
                          </Col>
                        </Row>
                        {/* <Button type="submit">Submit</Button> */}
                      </AvForm>
                      <hr />
                      {itemsForOrder && itemsForOrder.length > 0 && (
                        <>
                          <BootstrapTable
                            bootstrap4
                            keyField="_id"
                            data={itemsForOrder && itemsForOrder}
                            columns={columns_items}
                            noDataIndication="No data to display."
                            striped
                            hover
                            condensed
                          />
                          <AvForm onValidSubmit={handleValidUpdate}>
                            <Row>
                              <Col lg={6}>
                                <AvField
                                  name="remarks"
                                  value={remarks}
                                  onChange={(e) => {
                                    setRemarks(e.target.value);
                                  }}
                                  label={props.t("Remarks")}
                                  placeholder={props.t("Enter Remarks")}
                                  type="textarea"
                                />
                              </Col>
                              {/* <Col lg={12}>
                                            <div class="form-check">
                                              <input
                                                type="checkbox"
                                                name="is_urgent"
                                                className="is-untouched is-pristine av-valid form-check-input"
                                                checked={isUrgent}
                                                onChange={(e) => {
                                                  if (e.target.checked) {
                                                    setIsUrgent(true);
                                                  } else {
                                                    setIsUrgent(false);
                                                  }
                                                }}
                                              />
                                              <label for="select_all">
                                                {" "}
                                                {props.t(
                                                  "This is an urgent order."
                                                )}
                                              </label>
                                            </div>
                                          </Col> */}
                              <Col lg={12}>
                                <hr />
                                <FormGroup className="mb-0 text-left">
                                  <div>
                                    <Button
                                      type="submit"
                                      color="primary"
                                      className="mr-1"
                                    >
                                      {props.t("Update Order")}
                                    </Button>{" "}
                                  </div>
                                </FormGroup>
                              </Col>
                            </Row>
                          </AvForm>
                        </>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </>
          )}
        </ModalBody>
      </Modal>
      {/* Update Order Modal ends */}

      {/* Details Modal starts */}
      <Modal
        size="lg"
        isOpen={detailsModal}
        toggle={() => setDetailsModal(!detailsModal)}
        style={{ minWidth: "1200px", maxWidth: "1200px" }}
      >
        <ModalHeader toggle={() => setDetailsModal(!detailsModal)}>
          {props.t("Order Details")}
          {selectedOrder?.branch_order_id && (
            <>
              &nbsp; Generated Against :&nbsp;
              <span
                style={{
                  textDecoration: "underline",
                  color: "blue",
                  cursor: "pointer",
                }}
                onClick={handleOPenOrder}
              >
                {selectedOrder?.branch_order_id}
              </span>
            </>
          )}
        </ModalHeader>
        <ModalBody>
          <>
            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <Row>
                      {selectedOrder &&
                      yetToReceive &&
                      yetToReceive.length > 0 ? (
                        <>
                          <AvForm onValidSubmit={handleReceiveItemOrder}>
                            <Col lg={12} md={12}>
                              <br />
                              <Label>
                                <b>{props.t("Dispatched Items")} </b>
                              </Label>
                            </Col>
                            <Col lg={12} className="mb-4">
                              <BootstrapTable
                                bootstrap4
                                keyField="_id"
                                key="_id"
                                data={yetToReceive}
                                columns={columns_yet_to_receive}
                                cellEdit={cellEditFactory({
                                  mode: "click",
                                  blurToSave: true,
                                })}
                                noDataIndication="No data to display."
                                striped
                                hover
                                condensed
                              />
                            </Col>
                            <Col lg={12} className="text-center">
                              <Label>&nbsp;</Label>
                              <br />
                              <Button
                                type="submit"
                                color="primary"
                                disabled={receiveBtnDisabled}
                                className="btn btn-default waves-effect waves-light"
                              >
                                {props.t("Receive Items")}
                              </Button>
                              <hr />
                            </Col>
                          </AvForm>
                        </>
                      ) : null}

                      <Col lg={12} md={12}>
                        <Label>Ordered Items</Label>
                      </Col>

                      <Col lg={12}>
                        <BootstrapTable
                          bootstrap4
                          keyField="_id"
                          data={selectedOrder && selectedOrder.item_details}
                          columns={columns}
                          noDataIndication="No data to display."
                          striped
                          hover
                          condensed
                        />
                        <hr />
                      </Col>

                      {selectedOrder && received && received.length > 0 ? (
                        <>
                          <Col lg={12} md={12}>
                            <br />
                            <Label>
                              <b>{props.t("Received Items")} </b>
                            </Label>
                          </Col>
                          <Col lg={12} className="mb-4">
                            <BootstrapTable
                              bootstrap4
                              keyField="_id"
                              key="_id"
                              data={received}
                              columns={columns_received}
                              noDataIndication="No data to display."
                              striped
                              hover
                              condensed
                            />
                            <hr />
                          </Col>
                        </>
                      ) : null}
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </>
        </ModalBody>
      </Modal>
      {/* Details Modal ends */}

      {/* Edit Receive Quantity Modal */}
      <UpdateQuantityModal
        isOpen={receiveModal}
        toggle={() => setReceiveModal(false)}
        onSubmit={handleSubmit}
        item={selectedItem}
      />

      {/* Add Quantity modal  */}
      <Modal
        size="md"
        isOpen={selectUnitModal}
        // toggle={() => setSelectUnitModal(!selectUnitModal)}
        toggle={handleCloseModal}
        onClosed={handleCloseModal}
      >
        <ModalHeader toggle={() => setSelectUnitModal(!selectUnitModal)}>
          {props.t("Enter Quantity")}
        </ModalHeader>
        <ModalBody>
          <AvForm
            onValidSubmit={() => {
              handleAddUnits();
            }}
          >
            <Col lg={12}>
              <Table bordered size="sm" responsive className="table table-sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>{props.t("Unit")}</th>
                    <th>{props.t("Quantity")}</th>
                    <th>{props.t("Formula")}</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedItem?.unit_levels &&
                    selectedItem.unit_levels?.map((unitObj, index) => {
                      let prevUnit = index;
                      if (index == 0) {
                        prevUnit = "NA";
                      } else
                        prevUnit = selectedItem?.unit_levels[index - 1].unit;
                      return (
                        <tr key={index}>
                          <td>
                            <div class="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                checked={selectedRowsUnit.some(
                                  (row) => row.index === index && row.isChecked,
                                )}
                                id={`flexCheckDefault_${index}`}
                                onChange={() =>
                                  handleCheckboxChange(
                                    index,
                                    selectedItem,
                                    setSelectedRowsUnit,
                                  )
                                }
                              />
                            </div>
                          </td>
                          <td
                            onClick={() =>
                              handleCheckboxChange(
                                index,
                                selectedItem,
                                setSelectedRowsUnit,
                              )
                            }
                          >
                            {unitObj.unit}
                          </td>
                          <td>
                            <AvField
                              type="number"
                              className="form-control"
                              style={{ width: "60px", height: "20px" }}
                              placeholder="0"
                              name={unitObj.unit}
                              validate={{
                                required: {
                                  value: selectedRowsUnit?.some(
                                    (row) =>
                                      row.index === index && row.isChecked,
                                  )
                                    ? true
                                    : false,
                                },
                                min: {
                                  value: selectedRowsUnit?.some(
                                    (row) =>
                                      row.index === index && row.isChecked,
                                  )
                                    ? 1
                                    : 0,
                                  errorMessage:
                                    "Value must be greater than zero",
                                },
                              }}
                              errorMessage={props.t("Qty. can't be empty")}
                              disabled={
                                !selectedRowsUnit.some(
                                  (row) => row.index === index && row.isChecked,
                                )
                              }
                              value={
                                selectedRowsUnit.find(
                                  (row) => row.index === index,
                                )?.value
                              }
                              onChange={(e) => {
                                const quantity = e.target.value;
                                handleQuantityChange(
                                  index,
                                  quantity,
                                  setSelectedRowsUnit,
                                );
                              }}
                            />
                          </td>
                          <td>
                            {index > 0
                              ? "1" +
                                "  " +
                                prevUnit +
                                " = " +
                                unitObj.value +
                                " " +
                                unitObj.unit
                              : "NA"}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            </Col>

            <Row className="mt-3">
              <Col lg={12}>
                <FormGroup className="mb-0 text-center">
                  <div>
                    <Button type="submit" color="primary" className="mr-1">
                      {props.t("Add")}
                    </Button>
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </AvForm>
        </ModalBody>
      </Modal>
      {/* ---Open Order Deatils Start--- */}
      <OrderDetails
        isOpen={orderModal}
        toggle={() => setOrderModal(false)}
        details={viewOrderDetails}
      />
      {/* ---Open Order Deatils end--- */}
    </React.Fragment>
  );
};

export default withRouter(connect(null, {})(withNamespaces()(DeficitOrders)));
